import React, { useId } from "react";
import "../styles/VendorLoadingOverlay.css";

function VendorLogoSvg({ className = "" }) {
  const logoPath =
    "M20 134.15 L77.55 20 L140.65 121.3 L117.54 135.95 L70.78 94.31 L118.57 116.53 L77.59 55.94 Z";
  const roadPath =
    "M23.95 129.65 C32.95 111.25 44.7 90.25 57.2 66.75 C63.7 54.75 70.2 42.25 77.55 28 C86.2 42.5 94.7 57.75 102.95 72.25 C112.45 89.5 121.2 107 129.95 125.65 C127.9 128.1 125.8 130.1 123.5 131.6 C120.2 129.5 116.6 126.8 112.4 123.6 C103.6 116.9 92.2 108.4 73.7 93.25";
  const uniqueId = useId().replace(/:/g, "");
  const roadFillId = `roadFill-${uniqueId}`;
  const roadGlowId = `roadGlow-${uniqueId}`;
  const logoClipId = `logoClip-${uniqueId}`;
  const roadMaskId = `roadMask-${uniqueId}`;
  const baseShadeId = `baseShade-${uniqueId}`;

  return (
    <svg
      viewBox="0 0 180 180"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={roadFillId} x1="15%" y1="90%" x2="85%" y2="10%">
          <stop offset="0%" stopColor="#b88900" />
          <stop offset="48%" stopColor="#f5c30b" />
          <stop offset="100%" stopColor="#ffe58c" />
        </linearGradient>

        <filter id={roadGlowId} x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="4" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        <clipPath id={logoClipId}>
          <path d={logoPath} />
        </clipPath>

        <mask id={roadMaskId} maskUnits="userSpaceOnUse">
          <rect x="0" y="0" width="180" height="180" fill="#000" />

          <path
            d={roadPath}
            fill="none"
            stroke="#fff"
            strokeWidth="24"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="120 160"
          >
            <animate
              attributeName="stroke-dashoffset"
              from="280"
              to="0"
              dur="1.8s"
              repeatCount="indefinite"
            />
          </path>
        </mask>

        <linearGradient id={baseShadeId} x1="18%" y1="88%" x2="80%" y2="16%">
          <stop offset="0%" stopColor="#c7ced9" />
          <stop offset="100%" stopColor="#eef2f8" />
        </linearGradient>
      </defs>

      <path d={logoPath} fill={`url(#${baseShadeId})`} opacity="0.22" />
      <path
        d={logoPath}
        fill="none"
        stroke="#b8c1ce"
        strokeWidth="3"
        strokeLinejoin="round"
        opacity="0.45"
      />

      <g clipPath={`url(#${logoClipId})`}>
        <path
          d={logoPath}
          fill={`url(#${roadFillId})`}
          mask={`url(#${roadMaskId})`}
          filter={`url(#${roadGlowId})`}
          opacity="0.98"
        />

        <path
          d={roadPath}
          fill="none"
          stroke="#ffd95c"
          strokeWidth="9"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="64 216"
          opacity="0.82"
        >
          <animate
            attributeName="stroke-dashoffset"
            from="280"
            to="0"
            dur="1.8s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    </svg>
  );
}

function VendorLogoLoader({ isVisible = true }) {
  if (!isVisible) return null;

  return (
    <div className="vendor-loading-overlay">
      <VendorLogoSvg className="vendor-loading-logo" />
    </div>
  );
}

export { VendorLogoSvg, VendorLogoLoader };
export default VendorLogoLoader;
